import { render, staticRenderFns } from "./AccountRelation.vue?vue&type=template&id=058aa436"
import script from "./AccountRelation.vue?vue&type=script&lang=js"
export * from "./AccountRelation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports